// extracted by mini-css-extract-plugin
export default {"Fields":"FieldDataC_Fields__6QDCj"};